(() => {
  const normalize = value => String(value || '').trim().toUpperCase().replace(/[–—_-]+/g, ' ').replace(/\s+/g, ' ');
  const canonicalForm = value => {
    const form = normalize(value);
    if (/^(SWEATPANTS|PANTS|TROUSERS|TROUSER)$/.test(form)) return 'TROUSER';
    if (/^(HOODIE|HOODED PULLOVER|PULLOVER)$/.test(form)) return 'PULLOVER';
    return form;
  };
  const productCache = new Map();
  const historyKey = 'ferobrill_recent_products_v1';
  let memoryHistory = [];
  const canStore = () => !window.Shopify?.customerPrivacy || window.Shopify.customerPrivacy.preferencesProcessingAllowed();
  const readHistory = () => {
    try {
      const history = canStore() ? JSON.parse(localStorage.getItem(historyKey) || '[]') : memoryHistory;
      return Array.isArray(history) ? history.filter(item => item && /^[a-z0-9-]+$/.test(item.handle) && Number.isFinite(item.time) && Date.now() - item.time < 7 * 86400000).slice(0, 20) : [];
    } catch { return memoryHistory; }
  };
  const writeHistory = history => {
    memoryHistory = history;
    try { if (canStore()) localStorage.setItem(historyKey, JSON.stringify(history)); } catch {}
  };
  const recordViewed = (handle, variantId) => {
    if (!handle) return;
    const history = readHistory(), previous = history.find(item => item.handle === handle);
    const id = /^\d+$/.test(String(variantId || '')) ? String(variantId) : previous?.variantId;
    writeHistory([{handle,time:Date.now(),...(id ? {variantId:id} : {})},...history.filter(item => item.handle !== handle)].slice(0,20));
  };
  const getProduct = (handle, root) => {
    const key = root + handle;
    if (!productCache.has(key)) productCache.set(key, fetch(`${root}products/${encodeURIComponent(handle)}.js`, {credentials:'same-origin'}).then(response => {
      if (!response.ok) throw new Error('Product unavailable');
      return response.json();
    }).then(product => {
      if (!product || !product.id || product.handle !== handle) throw new Error('Invalid product');
      return product;
    }));
    return productCache.get(key);
  };
  const createCard = (product, host, variantId) => {
    const item = document.createElement('li'), link = document.createElement('a'), media = document.createElement('div');
    link.className = 'fb-product-card';
    link.href = `${host.dataset.root}products/${encodeURIComponent(product.handle)}`;
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    const linkUrl = new URL(link.href);
    if (preview) linkUrl.searchParams.set('preview_theme_id', preview);
    const variant = product.variants?.find(v => String(v.id) === String(variantId)) || product.variants?.find(v => v.available) || product.variants?.[0];
    if (variant) linkUrl.searchParams.set('variant', variant.id);
    link.href = linkUrl.href;
    media.className = 'fb-product-card__media';
    media.dataset.fbCardHandle = product.handle;
    if (variant) media.dataset.fbCardVariant = String(variant.id);
    let featuredImage = null;
    if (product.handle === host.dataset.handle && variant) {
      const formImageHost = host.querySelector('[data-fb-form-images]');
      if (formImageHost) {
        try {
          const formImages = JSON.parse(formImageHost.textContent);
          const names = continuityOptionNames(product);
          const formIndex = names.findIndex(name => /FORM|COORDINATE/i.test(name));
          const formName = formIndex >= 0 ? canonicalForm(variant.options[formIndex]) : '';
          featuredImage = formImages[formName] || null;
        } catch (_) {}
      }
    }
    featuredImage =
      featuredImage ||
      variant?.featured_image?.src ||
      variant?.featured_image ||
      product.featured_image?.src ||
      product.featured_image ||
      product.images?.[0]?.src ||
      product.images?.[0];
    if (featuredImage) {
      const img = document.createElement('img'), source = new URL(String(featuredImage), location.origin);
      if (source.protocol === 'https:') {
        source.searchParams.set('width', '600');img.src = source.href;
        img.alt = product.title;img.loading = 'lazy';img.decoding = 'async';img.width = 480;img.height = 600;media.append(img);
      }
    }
    if (!(variant ? variant.available : product.available)) { const badge = document.createElement('span');badge.className = 'fb-product-card__badge';badge.textContent = host.dataset.soldOut;media.append(badge); }
    const title = document.createElement('h3'), price = document.createElement('p');title.textContent = product.title;
    if (variant) {
      const names = product.options.map(option => typeof option === 'string' ? option : option.name);
      const formIndex = names.findIndex(name => /FORM|COORDINATE/i.test(name));
      const form = formIndex >= 0 ? variant.options[formIndex] : '';
      if (form) title.textContent = /PULLOVER$/.test(product.title) && canonicalForm(form) === 'TROUSER' ? product.title.replace(/PULLOVER$/, 'TROUSER') : product.title;
      const detail = document.createElement('span');detail.className = 'fb-product-card__detail';
      detail.textContent = variant.options.filter((value, index) => !/SIZE/i.test(names[index])).join(' · ');title.append(detail);
    }
    const money = new Intl.NumberFormat(host.dataset.locale || 'en', {style:'currency', currency:host.dataset.currency || 'USD'}).format((variant ? variant.price : product.price) / 100);
    price.textContent = `${!variant && product.price_varies ? host.dataset.from + ' ' : ''}${money}`;
    link.append(media, title, price);item.append(link);return item;
  };
  function initializeQuickViewSelection(page, config) {
    if (!page.closest('.kt-modal--product') || page.dataset.fbQuickSelectionReady) return;
    const variantsRoot = page.querySelector('product-variants');
    if (!variantsRoot) return;
    page.dataset.fbQuickSelectionReady = 'true';
    const groups = () => Array.from(variantsRoot.querySelectorAll('[data-js-product-variant-container]'));
    const selected = () => groups().map(group => group instanceof HTMLSelectElement ? group.value : group.querySelector('input:checked')?.value || '');
    const colorIndex = config.options.findIndex(name => /COLOR|COLOUR/i.test(name));
    const formIndex = config.options.findIndex(name => /FORM|COORDINATE|CATEGORY/i.test(name));
    const sizeIndex = config.options.findIndex(name => /SIZE/i.test(name));
    page.addEventListener('change', event => {
      const target = event.target;
      if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement) || !variantsRoot.contains(target)) return;
      const index = groups().findIndex(group => group === target || group.contains(target));
      if (colorIndex < 0 || formIndex < 0 || (index !== colorIndex && index !== formIndex)) return;
      const values = selected();
      if (config.variants.some(variant => variant.available && variant.options.every((value, i) => normalize(value) === normalize(values[i])))) return;
      const candidates = config.variants.filter(variant => variant.available && normalize(variant.options[index]) === normalize(values[index]));
      const score = variant => variant.options.reduce((total, value, i) => total + (normalize(value) === normalize(values[i]) ? (i === sizeIndex ? 4 : 1) : 0), 0);
      const match = candidates.reduce((best, variant) => !best || score(variant) > score(best) ? variant : best, null);
      if (!match) return;
      groups().forEach((group, i) => {
        if (group instanceof HTMLSelectElement) {
          group.value = match.options[i];
          Array.from(group.options).forEach(option => option.toggleAttribute('data-selected', option.selected));
        } else {
          group.querySelectorAll('input[type="radio"]').forEach(input => {
            input.checked = normalize(input.value) === normalize(match.options[i]);
            input.toggleAttribute('checked', input.checked);
            input.toggleAttribute('data-selected', input.checked);
          });
        }
      });
      const option = target instanceof HTMLSelectElement ? target.selectedOptions[0] : target;
      if (option) option.dataset.variantId = String(match.id);
    }, true);
  }
  function initializeConfidence(host) {
    if (host.dataset.ready) return;
    const config = JSON.parse(host.querySelector('[data-fb-config]').textContent);
    const page = host.closest('product-page') || host.closest('[data-js-product-component]');
    if (!page) return;
    host.dataset.ready = 'true';
    initializeQuickViewSelection(page, config);
    const formIndex = config.options.findIndex(name => /FORM|COORDINATE/i.test(name));
    const sizeIndex = config.options.findIndex(name => /SIZE/i.test(name));
    let unit = 'in', lastGuide = null, lastSize = null, lastForm = null, lastSelection = null, currentRecord;
    const renderTable = () => {
      if (!currentRecord) return;
      const sizes = currentRecord.sizes || [], rows = currentRecord.cm || [];
      const metrics = currentRecord.metrics || (rows[0]?.length === 3 ? ['LENGTH','WAIST','HIP'] : ['CHEST','LENGTH','SHOULDER','SLEEVE']);
      const thead = host.querySelector('thead'), tbody = host.querySelector('tbody');thead.replaceChildren();tbody.replaceChildren();
      const heading = document.createElement('tr');
      [config.sizeLabel, ...metrics].forEach(label => {const th = document.createElement('th');th.scope = 'col';th.textContent = label;heading.append(th)});thead.append(heading);
      sizes.forEach((size, i) => {
        const row = document.createElement('tr'), th = document.createElement('th');th.scope = 'row';th.textContent = size;row.append(th);
        if (normalize(size) === normalize(lastSize)) row.setAttribute('aria-current', 'true');
        (rows[i] || []).forEach(value => {const td = document.createElement('td');td.textContent = value == null ? '—' : unit === 'cm' ? `${value} cm` : `${(value / 2.54).toFixed(2)} in`;row.append(td)});tbody.append(row);
      });
    };
    const update = () => {
      const id = page.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      const variant = config.variants.find(v => String(v.id) === String(id));
      if (!variant) return;
      const form = formIndex >= 0 ? variant.options[formIndex] : '';
      const guideEntries = config.guides.length ? config.guides : window.FerobrillFormGuides?.[config.handle] || [];
      const matching = guideEntries.find(entry => canonicalForm(entry.form) === canonicalForm(form));
      const firstForm = formIndex >= 0 ? config.variants[0]?.options[formIndex] : '';
      const guide = matching?.guide || (!form || canonicalForm(firstForm) === canonicalForm(form) ? config.guide : '');
      const size = sizeIndex >= 0 ? variant.options[sizeIndex] : '';
      if (guide !== lastGuide || size !== lastSize) {
        lastGuide = guide;lastSize = size;currentRecord = window.FerobrillMeasurements?.[guide];
        const valid = !!(currentRecord && !currentRecord.pending && currentRecord.sizes?.length && currentRecord.cm?.length);
        host.querySelector('[data-fb-measurements]').hidden = !valid;host.querySelector('[data-fb-pending]').hidden = valid;
        host.querySelector('[data-fb-fit-copy]').textContent = valid ? [currentRecord.fit, currentRecord.copy].filter(Boolean).join(' — ') : '';
        const guideLink = host.querySelector('[data-fb-guide-link]'), url = new URL(guideLink.href);url.searchParams.delete('guide');if (guide) url.searchParams.set('guide', guide);guideLink.href = url.href;
        if (page.closest('.kt-modal--product')) {
          page.querySelectorAll('a.kt-size-chart-link').forEach(link => {
            link.href = url.href;
            link.removeAttribute('onclick');
            link.style.textDecoration = 'underline';
            if (guide) link.dataset.fbGuideId = guide;else delete link.dataset.fbGuideId;
          });
        }
        if (valid) renderTable();
      }
      if (String(variant.id) !== lastSelection) {recordViewed(config.handle,variant.id);lastSelection = String(variant.id);lastForm = form;window.dispatchEvent(new CustomEvent('ferobrill:selection', {detail:{form}}));}
    };
    host.querySelectorAll('[data-fb-unit]').forEach(button => button.addEventListener('click', () => {
      unit = button.dataset.fbUnit;host.querySelectorAll('[data-fb-unit]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));renderTable();
    }));
    let timer;
    const queue = () => {clearTimeout(timer);timer = setTimeout(update, 120)};
    page.addEventListener('change', queue);page.addEventListener('click', queue);
    page.addEventListener('VARIANT_CHANGE', queue, true);
    new MutationObserver(queue).observe(page, {childList:true, subtree:true, attributes:true, attributeFilter:['value']});
    update();
  }

  const continuityOptionNames = product => product.options.map(option => typeof option === 'string' ? option : option.name);
  const continuityKey = (product, variant) => product.handle + ':' + JSON.stringify(variant.options.filter((value, index) => !/SIZE/i.test(continuityOptionNames(product)[index])).map(normalize));
  const continuityVariant = (product, target, selectedSize) => {
    const names = continuityOptionNames(product);
    const color = names.findIndex(name => /COLOR|COLOUR/i.test(name));
    const form = names.findIndex(name => /FORM|COORDINATE/i.test(name));
    const size = names.findIndex(name => /SIZE/i.test(name));
    const matches = product.variants.filter(variant => variant.available &&
      (!target.variant || String(variant.id) === String(target.variant)) &&
      (!target.preferredColor || color >= 0 && normalize(variant.options[color]) === normalize(target.preferredColor)) &&
      (!target.preferredForm || form < 0 || canonicalForm(variant.options[form]) === canonicalForm(target.preferredForm)));
    return matches.find(variant => size >= 0 && normalize(variant.options[size]) === normalize(selectedSize)) || matches[0];
  };
  const continuityGroupTargets = (groups, current, config, selected, activeForm, activeColor) => {
    const exact = [], colorways = [];
    const role = value => {
      const text = normalize(value);
      if (/BERMUDA|SHORT/.test(text)) return 'BERMUDA';
      if (/TROUSER|PANTS|JEANS/.test(text)) return 'TROUSER';
      if (/T[ -]?SH[IR]*T|TEE/.test(text)) return 'T-SHIRT';
      if (/PULLOVER|HOODIE/.test(text)) return 'PULLOVER';
      if (/SWEATSHIRT|CREWNECK/.test(text)) return 'SWEATSHIRT';
      return canonicalForm(text);
    };
    const currentRole = role(activeForm || config?.title || groups.flatMap(group => group.products).find(product => product.handle === current)?.title || '');
    for (const group of groups) {
      for (const member of group.products) {
        const names = continuityOptionNames(member);
        const color = names.findIndex(name => /COLOR|COLOUR/i.test(name));
        const form = names.findIndex(name => /FORM|COORDINATE/i.test(name));
        const forms = form >= 0 ? member.values[form] : [group.form || role(member.title)];
        const colors = color >= 0 ? member.values[color] : [];
        for (const nextForm of forms) {
          if (group.type === 'coordinate_group') {
            if (!activeColor || !currentRole || role(nextForm) === currentRole || !colors.some(value => normalize(value) === normalize(activeColor))) continue;
            exact.push({handle:member.handle,preferredForm:form >= 0 ? nextForm : '',preferredColor:activeColor,relationship:'exact'});
          } else if (!activeForm || canonicalForm(nextForm) === canonicalForm(activeForm)) {
            for (const nextColor of colors) {
              if (normalize(nextColor) !== normalize(activeColor)) colorways.push({handle:member.handle,preferredForm:form >= 0 ? nextForm : '',preferredColor:nextColor,relationship:'colorway'});
            }
          }
        }
      }
    }
    if (selected && config) {
      const names = continuityOptionNames(config);
      const color = names.findIndex(name => /COLOR|COLOUR/i.test(name));
      const form = names.findIndex(name => /FORM|COORDINATE/i.test(name));
      const seenColors = new Set();
      for (const variant of config.variants) {
        if (!variant.available || color < 0 || normalize(variant.options[color]) === normalize(activeColor)) continue;
        if (form >= 0 && canonicalForm(variant.options[form]) !== canonicalForm(activeForm)) continue;
        const nextColor = normalize(variant.options[color]);
        if (seenColors.has(nextColor)) continue;
        seenColors.add(nextColor);
        colorways.push({handle:current,preferredColor:variant.options[color],preferredForm:activeForm,relationship:'colorway'});
      }
    }
    return {exact,colorways};
  };

  // Catalog fallback: live collection membership, never a frozen list of handles.
  const continuityRole = value => {
    const text = normalize(value);
    if (/DRESS|JUMPSUIT|ROMPER/.test(text)) return 'ONEPIECE';
    if (/TROUSER|PANTS|JEANS|LEGGING|BERMUDA|SHORT|SKORT|SKIRT/.test(text)) return 'BOTTOM';
    if (/JACKET|BLOUSON|CARDIGAN|FULL[ -]?ZIP|FULL ZIP/.test(text)) return 'LAYER';
    if (/SHIRT|SHRIT|TEE|TOP|BRALETTE|BRA|TANK|PULLOVER|HOOD|SWEAT|CREWNECK|KNIT/.test(text)) return 'TOP';
    return '';
  };
  const continuityFallbackTargets = (catalog, config, activeForm, activeColor, current) => {
    const sourceRole = continuityRole(activeForm || config.title);
    const family = normalize(config.title).match(/^THE (?:SOVEREIGN SCULPT|[A-Z]+)/)?.[0] || '';
    const style = normalize(config.title);
    const seenStyles = new Set();
    return catalog.flatMap(member => {
      if (member.handle === current) return [];
      const forms = member.forms.length ? member.forms : [''];
      const sameStyle = normalize(member.title) === style;
      const best = forms.map(form => {
        const role = continuityRole(form || member.title);
        let score = 0;
        if (sourceRole === 'ONEPIECE') { if (role !== 'LAYER') return null; score = 60; }
        else if (sourceRole === 'BOTTOM') { if (!['TOP','LAYER'].includes(role)) return null; score = role === 'TOP' ? 60 : 45; }
        else if (sourceRole === 'TOP' || sourceRole === 'LAYER') { if (role !== 'BOTTOM') return null; score = 60; }
        else { if (!role) return null; score = 30; }
        if (family && normalize(member.title).startsWith(family + ' ')) score += 12;
        const color = member.colors.find(color => normalize(color) === normalize(activeColor));
        if (color) score += 20;
        const neutral = member.colors.find(color => /OBSIDIAN|CHARCOAL|GREY|GRAY|CHALK|IVORY|LIMESTONE|TAUPE|IRON ORE|BLACK/.test(normalize(color)));
        if (neutral) score += 6;
        // Another listing of the same garment is a colorway, never an exact coordinate.
        if (sameStyle) return null;
        return {handle:member.handle,preferredForm:form,preferredColor:color || neutral || '',relationship:'styling',score,styleKey:normalize(member.title)};
      }).filter(Boolean).sort((a,b) => b.score - a.score)[0];
      return best ? [best] : [];
    }).sort((a,b) => b.score - a.score || a.handle.localeCompare(b.handle)).filter(target => {
      if (seenStyles.has(target.styleKey)) return false;
      seenStyles.add(target.styleKey);
      return true;
    });
  };

  function initializeDiscovery(host) {
    if (host.dataset.ready) return;host.dataset.ready = 'true';
    const root = host.dataset.root.endsWith('/') ? host.dataset.root : host.dataset.root + '/';host.dataset.root = root;
    const current = host.dataset.handle, history = readHistory();
    const recent = history.filter(item => item.handle !== current).slice(0, 8);
    const viewedId = document.querySelector('product-page form[action*="/cart/add"] input[name="id"]')?.value || new URLSearchParams(location.search).get('variant');
    recordViewed(current,viewedId);
    const recentRail = host.querySelector('[data-fb-recent-rail]'), recentList = host.querySelector('[data-fb-recent-list]');
    let cleared = false;
    const loadRecent = async () => {
      const products = await Promise.all(recent.map(async item => ({item,product:await getProduct(item.handle, root).catch(() => null)})));
      if (cleared) return;
      products.forEach(({item,product}) => {
        if (!product) return;
        const variant = product.variants?.find(v => String(v.id) === String(item.variantId)) || product.variants?.find(v => v.available) || product.variants?.[0];
        if (variant) {
          const card = createCard(product,host,variant.id);
          card.classList.add('fb-recent-item');
          if (variant.available) {
            const template = document.createElement('template');
            template.innerHTML = '<quick-view-product class="fb-recent-quick"><a class="fb-quick-tote kt-button kt-button--xxsmall kt-button--outline kt-button--loader"><span class="kt-button__text"><span class="kt-button__text-value"></span></span><svg viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M12 4v16M4 12h16" stroke="currentColor" stroke-width="1.5"/></svg></a></quick-view-product>';
            const quick = template.content.firstElementChild, button = quick.querySelector('a');
            button.href = card.querySelector('.fb-product-card').href;
            button.dataset.id = String(product.id);
            button.title = host.dataset.addToTote;
            button.setAttribute('aria-label',host.dataset.addToTote + ' · ' + product.title);
            button.querySelector('.kt-button__text-value').textContent = host.dataset.addToTote;
            quick.addEventListener('click', event => {
              event.preventDefault();
              if (!customElements.get('quick-view-product')) {
                event.stopImmediatePropagation();
                if (quick.dataset.fbWaiting === 'true') return;
                quick.dataset.fbWaiting = 'true';
                customElements.whenDefined('quick-view-product').then(() => {
                  quick.dataset.fbWaiting = 'false';
                  if (quick.isConnected) { quick.init();button.click(); }
                });
              } else quick.init();
            }, true);
            card.append(quick);
          }
          recentList.append(card);
        }
      });
      recentRail.hidden = !recentList.children.length;
      if (recentList.querySelector('quick-view-product') && !customElements.get('quick-view-product') && host.dataset.quickBuyScript) window.KrownAssetLoader?.loadScript(host.dataset.quickBuyScript);
    };
    if (recent.length) {
      const observer = new IntersectionObserver(entries => {if (entries.some(entry => entry.isIntersecting)) {observer.disconnect();loadRecent()}}, {rootMargin:'600px'});observer.observe(host);
    }
    host.querySelector('[data-fb-clear]').addEventListener('click', () => {cleared = true;writeHistory([]);try {localStorage.removeItem(historyKey)} catch {}recentList.replaceChildren();recentRail.hidden = true});
    host.querySelectorAll('[data-fb-scroll]').forEach(button => button.addEventListener('click', () => {
      const list = button.closest('section').querySelector('ul');list.scrollBy({left:Number(button.dataset.fbScroll) * list.clientWidth * .8, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
    }));
    let requestId = 0, lastHandles = null, pairingsPromise;
    const getPairings = () => {
      if (!pairingsPromise) pairingsPromise = Promise.all([host.dataset.fbPairingsUrl, host.dataset.fbBermudaPairingsUrl].map(url => url ? fetch(url, {credentials:'same-origin'}).then(response => response.ok ? response.json() : {}).catch(() => ({})) : Promise.resolve({}))).then(([base, bermudas]) => {
        Object.entries(bermudas).forEach(([handle, entry]) => {base[handle] = {...base[handle], ...entry};});
        return base;
      });
      return pairingsPromise;
    };
    const updateCoordinates = async (form = '') => {
      const token = ++requestId;
      const configHost = document.querySelector('[data-fb-confidence] [data-fb-config]');
      const continuityConfigHost = host.querySelector('[data-fb-continuity-config]');
      let config = null;
      if (configHost) {
        try { config = JSON.parse(configHost.textContent); } catch (_) {}
      }
      if (continuityConfigHost) {
        // Confidence data contains variants but omits the garment title and images.
        // Retain full product metadata so fallback classification has a real source role.
        try { config = {...JSON.parse(continuityConfigHost.textContent), ...(config || {})}; } catch (_) {}
      }
      if (!config) config = await getProduct(current, root).catch(() => null);
      if (config && host.dataset.fbPreviewProduct === 'true') {
        config = {...config, available:true, variants:(config.variants || []).map(variant => ({...variant, available:true}))};
      }
      const page = document.querySelector('product-page') || document.querySelector('[data-js-product-component]');
      const selectedId = page?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value;
      let selected = config?.variants.find(v => String(v.id) === String(selectedId)) || config?.variants.find(v => v.available) || config?.variants[0];
      const formIndex = config?.options.findIndex(name => /FORM|COORDINATE/i.test(name)) ?? -1;
      const sizeIndex = config?.options.findIndex(name => /SIZE/i.test(name)) ?? -1;
      const formControl =
        page?.querySelector('input[type="radio"][name*="COORDINATE" i]:checked, input[type="radio"][name*="FORM" i]:checked') ||
        page?.querySelector('select[name*="COORDINATE" i], select[name*="FORM" i]');
      const uiForm = formControl?.value || '';
      const activeForm = form || uiForm || (formIndex >= 0 ? selected?.options[formIndex] : '') || '';
      if (selected && formIndex >= 0 && activeForm && canonicalForm(selected.options[formIndex]) !== canonicalForm(activeForm)) {
        selected = config?.variants.find(variant =>
          variant.options.every((value, index) =>
            index === formIndex
              ? canonicalForm(value) === canonicalForm(activeForm)
              : normalize(value) === normalize(selected.options[index])
          )
        ) || selected;
      }
      const groups = Array.from(host.querySelectorAll('[data-fb-continuity-group]'), node => JSON.parse(node.textContent));
      const pairingEntry = groups.length ? undefined : (await getPairings())[current];
      if (selectedId !== page?.querySelector('form[action*="/cart/add"] input[name="id"]')?.value) return;
      const selectedKind = /TROUSER|PANTS|JEANS|SWEATPANTS|BERMUDA|SHORT/i.test(activeForm) ? 'BOTTOM' : activeForm ? 'TOP' : pairingEntry?.default;
      const bermudaContext = /BERMUDA|SHORT/i.test(activeForm) || (!activeForm && pairingEntry?.bermuda);
      const colorIndex = config?.options.findIndex(name => /COLOR|COLOUR/i.test(name)) ?? -1;
      const activeColor = (colorIndex >= 0 ? selected?.options[colorIndex] : '') || host.dataset.fbInitialColor || '';
      const grouped = continuityGroupTargets(groups, current, config, selected, activeForm, activeColor);
      const targets = [];
      const addTarget = target => {
        if (!targets.some(item => item.handle === target.handle && String(item.variant || '') === String(target.variant || '') && normalize(item.preferredForm) === normalize(target.preferredForm) && normalize(item.preferredColor) === normalize(target.preferredColor))) targets.push(target);
      };
      if (selected && formIndex >= 0) {
        const forms = new Set();
        for (const v of config.variants) {
          const nextForm = canonicalForm(v.options[formIndex]);
          if (bermudaContext && /TROUSER|PANTS|JEANS|BERMUDA|SHORT|SKORT|LEGGING/.test(nextForm)) continue;
          if (!v.available || !nextForm || nextForm === canonicalForm(activeForm) || forms.has(nextForm)) continue;
          if (!v.options.every((option, index) => index === formIndex || index === sizeIndex || option === selected.options[index])) continue;
          forms.add(nextForm);addTarget({handle:current,preferredForm:v.options[formIndex],preferredColor:activeColor,relationship:'exact'});
        }
      }
      grouped.exact.forEach(addTarget);
      const managedGroup = groups.length > 0;
      const teeContext = /\bT[ -]?(?:SHIRT|SHRIT)\b|\bTEE\b/i.test(activeForm) || (!activeForm && pairingEntry?.tee);
      if (teeContext && !managedGroup) {
        const colors = pairingEntry?.TOP_BERMUDAS_BY_COLOR || {};
        const key = Object.keys(colors).find(color => normalize(color) === normalize(activeColor));
        for (const target of colors[key] || []) addTarget(target);
      }
      const sources = Array.from(host.querySelectorAll('[data-fb-coordinate-sources]>div'));
      const chosen = sources.find(source => source.dataset.form && canonicalForm(source.dataset.form) === canonicalForm(activeForm));
      const appendLinks = (scope, preferredForm = '') => scope?.querySelectorAll('a[href]').forEach(link => {
        const url = new URL(link.getAttribute('href'), location.origin), match = url.pathname.match(/\/products\/([a-z0-9-]+)/);
        const variant = url.searchParams.get('variant');
        if (url.origin === location.origin && match && match[1] !== current) addTarget({handle:match[1],variant,preferredForm});
      });
      if (!bermudaContext && !managedGroup) appendLinks(chosen || sources[0]);
      const curated = Array.from(host.querySelectorAll('[data-fb-curated-sources]>div')).filter(source => !source.dataset.sourceColor || normalize(source.dataset.sourceColor) === normalize(activeColor));
      const exact = curated.filter(source => source.dataset.sourceForm && canonicalForm(source.dataset.sourceForm) === canonicalForm(activeForm));
      const matching = exact.length ? exact : curated.filter(source => !source.dataset.sourceForm);
      matching.forEach(source => appendLinks(source,source.dataset.recommendForm));
      if (!matching.length && !managedGroup) {
        const colorPairings = selectedKind === 'BOTTOM' ? pairingEntry?.BOTTOM_BY_COLOR : null;
        const colorKey = Object.keys(colorPairings || {}).find(key => normalize(key) === normalize(activeColor));
        for (const target of (colorKey ? colorPairings[colorKey] : pairingEntry?.[selectedKind]) || []) addTarget(target);
      }
      grouped.colorways.forEach(addTarget);

      const fallbackTargets = {
        'the-imperium-vault-full-zip-pullover-foundry-grey': [
          {handle:'the-chancellor-310-v-neck-crop-t-shirt-foundry-grey',preferredColor:'FOUNDRY GREY',relationship:'styling'},
          {handle:'the-imperium-vector-hooded-pullover-foundry-grey-cerulean-stone',relationship:'styling'},
          {handle:'unisex-waffle-boxy-t-shirt',preferredColor:'FOUNDRY GREY',preferredForm:'T-SHRIT',relationship:'styling'},
          {handle:'the-chancellor-flare-trouser-stone-charcoal',relationship:'styling'},
          {handle:'womens-vintage-wash-wide-leg-denim-jeans',relationship:'styling'}
        ]
      };
      for (const target of fallbackTargets[current] || []) {
        if (targets.length >= 6) break;
        addTarget(target);
      }

      let catalog = [];
      try { catalog = JSON.parse(host.querySelector('[data-fb-continuity-catalog]')?.textContent || '[]'); } catch (_) {}
      // Separate listings of an identical style can supply additional colorways.
      let automaticColorways = 0;
      for (const member of catalog) {
        if (automaticColorways >= 2) break;
        if (member.handle === current || normalize(member.title) !== normalize(config?.title)) continue;
        if (activeForm && member.forms.length && !member.forms.some(value => canonicalForm(value) === canonicalForm(activeForm))) continue;
        const color = member.colors.find(value => normalize(value) !== normalize(activeColor));
        if (!color) continue;
        addTarget({handle:member.handle,preferredForm:activeForm,preferredColor:color,relationship:'colorway'});
        automaticColorways++;
      }
      continuityFallbackTargets(catalog, config || {}, activeForm, activeColor, current).slice(0,24).forEach(addTarget);
      if (token !== requestId) return;
      const signature = JSON.stringify([targets,selected?.id]);if (signature === lastHandles) return;
      const rail = host.querySelector('[data-fb-coordinate-rail]'), list = host.querySelector('[data-fb-coordinate-list]');
      rail.setAttribute('aria-busy', 'true');
      const products = [], seen = new Set();
      const currentProduct = config ? {...config,handle:current} : null;
      const currentKey = currentProduct && selected ? continuityKey(currentProduct,selected) : '';
      for (let offset = 0; offset < targets.length && products.length < 6; offset += 6) {
        const batch = await Promise.all(targets.slice(offset,offset + 6).map(async target => {
          const product = target.handle === current && config
            ? {...config, handle:current, available:true}
            : await getProduct(target.handle, root).catch(() => null);
          if (!product || (target.handle !== current && !product.available)) return null;
          const variant = continuityVariant(product,target,sizeIndex >= 0 ? selected?.options[sizeIndex] : '');
          return variant ? {product,variant,relationship:target.relationship || 'styling'} : null;
        }));
        if (token !== requestId) return;
        for (const result of batch) {
          if (!result) continue;
          const key = continuityKey(result.product,result.variant);
          if (key === currentKey || seen.has(key)) continue;
          seen.add(key);products.push(result);
          if (products.length === 6) break;
        }
      }
      if (token !== requestId) return;
      const cards = products.map(result => {
        const card = createCard(result.product,host,result.variant.id);
        const label = document.createElement('span');label.className = 'fb-product-card__detail';
        label.textContent = host.dataset[result.relationship === 'exact' ? 'fbExactLabel' : result.relationship === 'colorway' ? 'fbColorwayLabel' : 'fbStylingLabel'];
        card.querySelector('h3').append(label);
        return card;
      });
      rail.removeAttribute('aria-busy');
      list.replaceChildren(...cards);rail.hidden = !cards.length;lastHandles = signature;
    };
    window.addEventListener('ferobrill:selection', event => updateCoordinates(event.detail.form));updateCoordinates();
    document.addEventListener('visitorConsentCollected', () => {if (!canStore()) {cleared = true;memoryHistory = [];try {localStorage.removeItem(historyKey)} catch {}recentList.replaceChildren();recentRail.hidden = true}});
  }
  const refineContinuityImage = image => {
    if (!(image instanceof HTMLImageElement) || !image.closest('[data-fb-coordinate-list]') || !image.naturalWidth || !image.naturalHeight) return;
    const ratio = image.naturalWidth / image.naturalHeight;
    image.classList.toggle('fb-flat-photo', ratio >= .95 && ratio <= 1.05);
  };
  document.addEventListener('load', event => refineContinuityImage(event.target), true);
  const initialize = () => {
    document.querySelectorAll('[data-fb-coordinate-list] img').forEach(refineContinuityImage);
    document.querySelectorAll('[data-fb-discovery]').forEach(initializeDiscovery);
    document.querySelectorAll('[data-fb-confidence]').forEach(initializeConfidence);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize);else initialize();
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('krown:product-modal:init', initialize);
  document.addEventListener('krown:product-modal:show', initialize);
})();







